import { render, staticRenderFns } from "./ChannelForm.vue?vue&type=template&id=5ec30364"
import script from "./ChannelForm.vue?vue&type=script&lang=js"
export * from "./ChannelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports